import { useContext } from 'react';
import { BrandKitContext } from './brand-kit-context';
import type { BrandKit } from './types';

export const useBrandKit = (): BrandKit => useContext(BrandKitContext);
